import React from "react";
import ReactDOM from "react-dom";
import { ThemeProvider } from "@material-ui/styles";
import { createTheme } from "@material-ui/core/styles";
import { createMuiTheme } from "@material-ui/core"
import PoppinsRegularTtf from './fonts/Poppins-Regular.ttf';
import { Router } from "react-router-dom";
import { BrowserRouter } from "react-router-dom";
import { I18nextProvider } from "react-i18next";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import LoadingProps from "./utils/LoadingProvider";
import i18n from "./utils/i18n";
import { createBrowserHistory } from 'history';
import { CookiesProvider } from "react-cookie";

const history = createBrowserHistory();
const defaultTheme = createMuiTheme({  })
const { breakpoints, typography: { pxToRem } } = defaultTheme

const theme = createTheme({
  typography: {
    fontFamily: 'Poppins, Arial',
  },
  palette: {
    primary: {
      light: '#333333',
      main: '#000000',
      dark: '#000000',
      contrastText: '#BCBCBC',
      contrastTextLight: '#fff',
    },
    secondary: {
      light: '#962013',
      main: '#000000',
      dark: '#962013',
      contrastText: '#fff',
    },
  },
  overrides: {
    MuiCssBaseline: {
      '@global': {
        body: {
          backgroundColor: '#E5E5E5',
        },
      },
    },
    MuiFormControl: {
      root: {
        marginTop: '10px',
        
      },
    },
    MuiButton: {
      root: {
        margin: 4,
        textTransform: 'none',
        borderRadius: 0,
        marginTop: "15px",
        marginBottom: "15px",
      },
      outlined: {
        backgroundColor: '#ffffff',
        borderColor: '#000000',
        color: '#000000',
        fontSize: '18px',
        margin: '10px 0px',
        padding: '16px 20px',
        '&:hover': {
          backgroundColor: '#dddddd',
        },
      },
      contained: {
        backgroundColor: '#000000',
        color: '#ffffff',
        fontSize: '18px',
        margin: '10px 0px',
        padding: '16px 20px',
        '&:hover': {
          backgroundColor: '#333333',
        },
        '&:disabled': {
          backgroundColor: '#000000',
          color: '#ffffff',
        },
      },
    },
    MuiSelect: {
      root: {
        background: '#ffffff',
      },
    },
    MuiInput: {
      root: {
        
      },
      
    },
    MuiOutlinedInput: {
      root: {
        borderColor: "#CCCCCC",
        height: "58px",
        margin: "5px 0px",
        borderRadius: 0,
        fontSize: "14px",
        '&::before': {
          border: "none",
        },
        '&.MuiInput-underline:after': {
          borderBottom: "none",
        },
        '&.Mui-disabled':{
          backgroundColor: "#EBEBEB"
        },
      },
    },
    MuiTextField: {
      root: {
        margin: 4,
        marginLeft: '0px',
        // minWidth: 120,
        '& label': {
          color: '#cccccc',
        },
      },
    },
    MuiInputLabel: {
      outlined: {
        color: "#333333",
        fontSize: "14px",
        transform: 'none',
        '&.MuiInputLabel-formControl': {
          transform: "initial",
        },
      },
    },
    MuiFormHelperText: {
      root: {
        color: '#bcbcbc',
        marginTop: '0',
      },
      contained: {
        marginLeft: '0',
        marginBottom: '12px',
      },
    },
    MuiTab: {
      root: {
        textTransform: 'capitalize',
        '&.Mui-selected': {
          background: 'white',
        },
      },
    },
    MuiTable: {
      root: {
        minWidth: 650,
        backgroundColor: 'white',
      },
    },
    MuiTableRow: {
      root: {
        color: '#306F9D !important',
        backgroundColor: 'white',
      },
    },
    MuiTypography: {
      gutterBottom: {
        marginBottom: '6em',
      },
      body1: {
        color: '#000000',
        fontSize: "14px",
        lineHeight: "21px",
      },
      body2: {
        color: '#FFFFFF',
        fontSize: "13px",
        lineHeight: "19.5px",
        [breakpoints.up("md")]: {
          fontSize: "14px",
        lineHeight: "21px",
        }
      },
      h1: {
        fontWeight: '400',
        fontSize: pxToRem(18),
        lineHeight: '28.8px',
        margin: '20px 0px',
        [breakpoints.up("md")]: {
          fontSize: pxToRem(28)
        }
      },
      h2: {
        fontWeight: 'normal',
        fontSize: pxToRem(14),
        lineHeight: pxToRem(21),
        color: '#727272',
        margin: '10px 0px',
        [breakpoints.up("md")]: {
          fontSize: pxToRem(18),
          lineHeight: pxToRem(27),
        }
      },
      h3: {
        fontWeight: 'normal',
        fontSize: pxToRem(14),
        lineHeight: pxToRem(21),
        color: '#727272',
        margin: '10px 0px',
        [breakpoints.up("md")]: {
          fontSize: pxToRem(14),
          lineHeight: pxToRem(21),
        }
      },
      h4: {
        fontSize: '1.65rem',
      },
      h6: {
        fontSize: '1rem',
      },
    },
    MuiChip: {
      root: {
        height: 'initial',
      },
    },
    MuiToggleButton: {
      root: {
        width: '100%',
        color: '#000000',
        textTransform: 'capitalize',
        border: '1px solid #000000',
        borderRadius: 0,
        lineHeight: '1',
        '&$selected': {
          backgroundColor: '#000000',
          color: 'white',
          '&:hover': {
            backgroundColor: '#000000',
            color: 'white',
          },
        },
      },
    },
    MuiCheckbox: {
      colorPrimary: {
        color: '#CCCCCC',
        '&$checked': {
          color: '#000000',
        },
      },
    },
    MuiLinearProgress: {
      root: {
        top: "-14px",
      },
      colorPrimary: {
        backgroundColor: '#A5CBE7',
      },
      barColorPrimary: {
        backgroundColor: '#1E8BDA',
      },
    },
    MuiDivider: {
      root: {
        backgroundColor: 'rgba(159, 163, 168, 0.5)',
      },
    },
    MuiPickersToolbarText: {
      toolbarTxt: {
        color: '#BCBCBC',
      },
      toolbarBtnSelected: {
        color: 'white',
      },
    },
    MuiPickersToolbar: {
      toolbar: {
        backgroundColor: '#306F9D',
      },
    },
    MuiPickerDTTabs: {
      tabs: {
        backgroundColor: '#306F9D !important',
        color: 'white',
        '& .MuiTab-root.Mui-selected': {
          backgroundColor: '#306F9D !important',
        },
      },
    },
  },
});

ReactDOM.render(
  <React.StrictMode>
    <CookiesProvider>
      <Router history={history}>
        <ThemeProvider theme={theme}>
          <LoadingProps>
            <I18nextProvider i18n={i18n}>
              <App />
            </I18nextProvider>
          </LoadingProps>
        </ThemeProvider>
      </Router>
    </CookiesProvider>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
